  loadVariantProductsNew();

function loadVariantProductsNew() {
  const productTagsEl = document.querySelector(".product-tags");
  if (!productTagsEl) return;

  const variantTags = productTagsEl.getAttribute("data-tags");
  const variantSettings = productTagsEl.getAttribute("data-variant-setting");

  if (!variantTags || variantSettings !== "images") return;

  const query = variantTags.split(",").map(tag => `tag:${tag}`).join(" OR ");
  const searchUrl = `/search?q=${variantTags}`;

  fetch(searchUrl)
    .then(res => res.text())
    .then(htmlString => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");

      const variantWrapper = doc.querySelector(".hidden__variants_wrap");
      if (!variantWrapper) return;

      const slides = variantWrapper.querySelectorAll(".swiper-slide");
      const targetWrapper = document.querySelector(".variants-slider .swiper-wrapper");
      if (!targetWrapper) return;

      // Voeg de slides toe aan de Swiper-wrapper
      targetWrapper.innerHTML = ""; // leeg eerst huidige inhoud
      slides.forEach(slide => {
        const slideTag = slide.dataset.tags;
        if(slideTag == variantTags){
          targetWrapper.appendChild(slide.cloneNode(true)); // kopieer zonder disconnecting originele DOM
        }
      });

      document.querySelector(".variants-slider")?.classList.add("loaded");
      mountVariantSliderNew();
    })
    .catch(err => console.error("Fout bij laden van varianten:", err));
}


function mountVariantSliderNew() {
  const variantSettings = document.querySelector(".product-tags")?.getAttribute("data-variant-setting");
  const container = document.querySelector(".variants-slider");

  if (!container || !variantSettings) return;

  // Basisafmetingen instellen
  let slideSize = {
    width: 75,
    height: 75
  };

  // Pas Swiper slide styles toe
  const slides = container.querySelectorAll(".swiper-slide");
  slides.forEach(slide => {
    slide.style.width = `${slideSize.width}px`;
    slide.style.height = `${slideSize.height}px`;
  });

  const swiper = new Swiper(".variants-slider", {
    slidesPerView: 10,
    spaceBetween: 10,
    speed: 700,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      0:{
        slidesPerView: 4,
      },
      767: {
        slidesPerView: 10,
      }
    }
  });

  // Overflow check: als alle slides passen → disable arrows en swipe
  requestAnimationFrame(() => {
    const wrapper = container.querySelector(".swiper-wrapper");
    const totalSlidesWidth = wrapper.scrollWidth;
    const visibleWidth = container.clientWidth;

    if (totalSlidesWidth <= visibleWidth) {
      swiper.allowTouchMove = false;
      const prevBtn = container.querySelector(".swiper-button-prev");
      const nextBtn = container.querySelector(".swiper-button-next");
      prevBtn?.classList.add("swiper-disabled");
      nextBtn?.classList.add("swiper-disabled");
    }
  });
}